import { AgGridReact } from 'ag-grid-react';

import { PayrollEmployeeData } from '../[period]/[type]/inputs/types';

export const useFilterAgGrid = (column: string) => {
  const applyFilter = async (
    gridRef: AgGridReact<PayrollEmployeeData>,
    searchTerm: string,
  ) => {
    const api = gridRef.api;
    if (!api) return;

    if (searchTerm) {
      await api.setColumnFilterModel(column, {
        type: 'contains',
        filter: searchTerm,
      });
    } else {
      await api.setColumnFilterModel(column, null);
    }

    api.onFilterChanged();
  };
  return {
    applyFilter,
  };
};
